import React from 'react';

const EntityAvatar = ({ entity }) => (
   <div className="flex flex-row items-center gap-3">
      {entity.thumbnail ? (
         <img
            className="h-10 w-10 flex-shrink-0 rounded-full object-cover grayscale ring-1 ring-white/15 transition group-hover:grayscale-0 group-hover:ring-signal"
            src={entity.thumbnail}
            alt=""
         />
      ) : (
         <div className="h-10 w-10 flex-shrink-0 rounded-full bg-ink-700 ring-1 ring-white/10" />
      )}
      <p className="font-medium text-bone">{entity.name}</p>
   </div>
);

export default EntityAvatar;
